import React, { Component } from 'react';
import './App.css';

class Footer extends Component {
  render() {
    return (
      <div className="Footer">
      <p>Regd. Office: QTC Ltd, Lifestyle House, 157-167 Sheffield Road</p>
      <p>Sheffield S21 1DY</p>
      <p>Tel: 07710 506269</p>
      <p>Email: info@qtc-ltd.co.uk</p>
      <p>VAT Reg No: 828 2280 26 &nbsp; &nbsp; Company Reg No: 4884683</p>
      <p><a href="https://www.moovashaka.co.uk" noopener noreferer target="blank">Powered by MoovaShaka</a></p>
      </div>
    );
  }
}

export default Footer;
